// Replace direct database calls with API calls to backend
import { apiClient } from '@/lib/api-client';

export default async function findUser(params: { username?: string; id?: string } | string) {
  try {
    let findParams: { username?: string; id?: string };
    
    // Handle both string and object parameters for backward compatibility
    if (typeof params === 'string') {
      const identifier = params;
      // Check for CUID format (starts with 'c' and is 25 characters long) or UUID format
      const isId = /^c[a-z0-9]{24}$/i.test(identifier) || /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(identifier);
      
      if (isId) {
        findParams = { id: identifier };
      } else {
        findParams = { username: identifier };
      }
    } else {
      if (params.id) {
        findParams = { id: params.id };
      } else if (params.username) {
        findParams = { username: params.username };
      } else {
        throw new Error('Must provide either id or username');
      }
    }
    
    console.log('🔍 Finding user with params:', findParams);
    const response = await apiClient.findUser(findParams);
    console.log('✅ User found:', response.user);
    
    // Return the user object from the response
    return response.user;
  } catch (error) {
    console.error('Error finding user:', error);
    return null;
  }
}
